import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faSearch,
  faEllipsisH,
  faEye,
  faEdit,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  Breadcrumb,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
  Card,
  Table,
  Dropdown,
  Spinner,
} from "@themesberg/react-bootstrap";
import { useHistory } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function ProdukPage() {
  const history = useHistory();
  const [produkList, setProdukList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Sesi kamu telah berakhir, silakan login kembali.");
      history.push("/login");
      return;
    }

    try {
      const decoded = jwtDecode(token);

      if (decoded.exp * 1000 < Date.now()) {
        localStorage.removeItem("token");
        alert("Token kamu sudah kedaluwarsa, silakan login ulang.");
        history.push("/login");
        return;
      }

      setUserRole(decoded.role);
    } catch (err) {
      console.error("Token invalid:", err);
      localStorage.removeItem("token");
      history.push("/login");
    }
  }, [history]);

  const fetchProduk = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("Sesi kamu telah berakhir, silakan login kembali.");
        history.push("/login");
        return;
      }
      const response = await fetch(`${process.env.REACT_APP_API_URL}/produk`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      setProdukList(data);
    } catch (error) {
      console.error("Gagal mengambil data produk:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, nama) => {
    const yakin = window.confirm(`Apakah kamu yakin ingin menghapus produk "${nama}"?`);
    if (!yakin) return;

    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/produk/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        alert("Produk berhasil dihapus");
        fetchProduk();
      } else {
        const text = await response.text();
        alert(`Gagal menghapus produk: ${text}`);
      }
    } catch (error) {
      console.error("Gagal menghapus produk:", error);
      alert("Terjadi kesalahan saat menghapus produk ");
    }
  };

  useEffect(() => {
    fetchProduk();
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block breadcrumb-dark breadcrumb-transparent">
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Volt</Breadcrumb.Item>
            <Breadcrumb.Item active>Produk</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Daftar Produk</h4>
          <p className="mb-0">Data produk</p>
        </div>

        {userRole === "admin" && (
          <div className="btn-toolbar mb-2 mb-md-0">
            <ButtonGroup>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => history.push("/produk/add")}
              >
                Tambah
              </Button>
            </ButtonGroup>
          </div>
        )}
      </div>

      <div className="table-settings mb-4">
        <InputGroup style={{ maxWidth: "400px" }}>
          <InputGroup.Text>
            <FontAwesomeIcon icon={faSearch} />
          </InputGroup.Text>
          <Form.Control type="text" placeholder="Cari produk..." />
        </InputGroup>
      </div>

      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body>
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          ) : produkList.length === 0 ? (
            <p className="text-center mt-4">Tidak ada data produk.</p>
          ) : (
            <Table hover className="user-table align-items-center">
              <thead>
                <tr>
                  <th>Nama</th>
                  <th>Komposisi</th>
                  <th>Kelebihan</th>
                  <th>Fungsi</th>
                  <th>Cara Penggunaan</th>
                  <th>Harga Stokis</th>
                  <th>Harga Reseller</th>
                  <th>Harga Agen</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {produkList.map((produk) => (
                  <tr key={produk.id}>
                    <td>{produk.nama}</td>
                    <td>{produk.komposisi}</td>
                    <td>{produk.kelebihan}</td>
                    <td>{produk.fungsi}</td>
                    <td>{produk.cara_penggunaan}</td>
                    <td>{produk.harga_stokis}</td>
                    <td>{produk.harga_reseller}</td>
                    <td>{produk.harga_agen}</td>
                    <td>
                      <Dropdown as={ButtonGroup}>
                        <Dropdown.Toggle
                          as={Button}
                          split
                          variant="link"
                          className="text-dark m-0 p-0"
                        >
                          <span className="icon icon-sm">
                            <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
                          </span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => history.push(`/produk/${produk.id}`)}>
                            <FontAwesomeIcon icon={faEye} className="me-2" /> Lihat
                          </Dropdown.Item>

                          {userRole === "admin" && (
                            <>
                              <Dropdown.Item
                                onClick={() => history.push(`/produk/edit/${produk.id}`)}
                              >
                                <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
                              </Dropdown.Item>
                              <Dropdown.Item
                                className="text-danger"
                                onClick={() => handleDelete(produk.id, produk.nama)}
                              >
                                <FontAwesomeIcon icon={faTrashAlt} className="me-2" /> Hapus
                              </Dropdown.Item>
                            </>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </>
  );
}
